import { useState, useMemo, useEffect, useRef } from 'react';
import '../../assets/css/StudentDashboard.css'
import SearchBar from '../../Component/SearchBar';
import { SuccessfulPopup } from '../../Component/Modals/SuccessfulPopup';
import Table from '../../Component/Table';
import edit from '../../assets/icons/editnew.svg';
import { useNavigate } from 'react-router-dom';
import { AddOrganisationModal } from '../../Component/Modals/AddOrganisationModal.js';
import { getData, getDataById, patchData, Postdata, Postdataform, PostdataWithJson, updateData, UpdateDataForm, UpdateDataFormWithJson } from '../../API/GlobalApi.js';
import { ClassShortDetails } from './ClassShortDetails.js';
import { Addfee } from '../../Component/Modals/AddFee.js';
import debounce from 'lodash.debounce';
import { useTableFade } from '../../Utils/tableFadeHooks.js';
import AdvanceTable from '../../Utils/AdvanceTables.js';
import SearchingBar from '../../Utils/Searching.js';
import TableSkeleton from '../../Utils/TableSkeleton.js';
import TableLoaderOverlay from '../../Utils/tableFadingLoader.js';
import SpinnerLoader from '../../Utils/Spinner.js';


export const ClassDashboard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFeeModalOpen, setIsFeeModalOpen] = useState(false);
  const [isModalOpendept, setIsModalOpendept] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [classTotalCount, setClassTotalCount] = useState(0);
  const [classData, setClassData] = useState([]);
  const [submit, setsubmit] = useState(false);
  const [dnparentdata, setdnparentdata] = useState([]);
  const [dnparentdata2, setdnparentdata2] = useState([]);
  const [countryId, setcountryId] = useState(null);
  const [countrydata, setcountrydata] = useState([]);
  const [statedata, setstatedata] = useState([]);
  const [citydata, setcitydata] = useState([]);
  const [stateid, setstateid] = useState(null);
  const [cityid, setcityid] = useState(null);
  const [selectedOrgDetails, setSelectedOrgDetails] = useState([]);
  const [departmentdetails, setdepartmentdetails] = useState(null);
  const [parentorgid, setparentorgid] = useState(null);
  const [parentorgidsub, setparentorgidsub] = useState(null);
  const [Updatebtn, setUpdatebtn] = useState(false);
  const [status, setStatus] = useState(false);
  const [masterdata, setmasterdata] = useState([]);
  const [coursedata, setcoursedata] = useState([]);
  const [specdata, setspecdata] = useState([]);


  const [currentClassPage, setCurrentClassPage] = useState(0);

  const [orgform, setorgform] = useState({
    name: "",
    academic_group: null,
    intakelimit: null,
    courseid: null,
    specid: null

  })
  const [deptform, setdeptform] = useState({
    id: null,
    name: "",
    course_code: "",
    semester_fee: "",
    provisional_fee: "",
    intech_capacity: null
  })

  const [feeForm, setFeeform] = useState({
    provisional_fee: "",
    fees: "",
    intake_limit: ""
  });


  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');
  const displayToast = (message, variant = 'success') => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };
  const [searchQuery, setSearchQuery] = useState('')
  const navigate = useNavigate();


  const [filteredData, setFilteredData] = useState([]);





  const isRequired = (val) => {
    if (val === null || val === undefined) return false;
    return String(val).trim() !== '';
  };


  const [allClassData, setAllClassData] = useState([]);

  const getmasterdata = async () => {
    const url = "academics/get-academic-groups/";
    const response = await getData(url);
    if (response) {
      setmasterdata(response);
      const formattedData = response?.map((org) => ({
        id: org?.id,
        class_name: org?.name,
        academic_group: org?.name,
        specialization: org?.specialization?.name,
        course: org?.specialization?.course?.name,
        course_code: org?.specialization?.course_code,
        status: org?.status,
        academic_group_id: org?.id,
        intake_limit: org?.intake_limit
      }));


      setAllClassData(formattedData);
    }
  };

  const getcourse = async () => {
    const url = "academics/courses/";
    const response = await getData(url);

    if (response) {
      setcoursedata(response.results);


    }
  }
  const getspec = async () => {
    const url = `academics/courses/${orgform.courseid}/specializations/`;
    const response = await getData(url);
    if (response) {
      setspecdata(response.results);

    }
  }
  const handleClassPageChange = ({ selected }) => {
    setCurrentPage(selected);
    triggerTableLoading();
  };


  const skipSpinnerRef = useRef(false);
  const [totalCount, setTotalCount] = useState(0);
  const pageSize = 10;
  const pageCounts = Math.ceil(totalCount / pageSize);
  const [isSearching, setIsSearching] = useState(false); // search has value
  const [isSearchLoading, setSearchLoading] = useState(false);
  const [isSearchPending, setIsSearchPending] = useState(false);
  const showSpinner = isSearchPending || isSearchLoading;
  const [filterQueryString, setFilterQueryString] = useState('');
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const { tableLoading, triggerTableLoading, stopTableLoading } = useTableFade();

  const flattenClassData = (data) => {
    return data.map((org) => {
      const specialization = org.specialization || {};
      const course = specialization.course || {};
      return {
        id: org.id,
        class_name: org.name || "",
        academic_group: org.name || "",
        specialization: specialization.name || "",
        specialization_id: specialization.id || null,
        course: course.name || "",
        course_code: specialization.course_code || "",
        alias: course.alias || "",
        level: course.level || "N/A",
        mode: course.mode || "N/A",
        mode_count: course.mode_count || 0,
        duration: course.duration || 0,
        organization: course.organization?.name || "N/A",
        organization_id: course.organization?.id || null,
        intake_limit: org.intake_limit || 0,
        fees: org.fees || 0,
        provisional_fee: org.provisional_fee || 0,
        status: org.status || false,
        handleRowClick,
      };
    });
  };


  const getorgdata = async (page = 0, filters = filterQueryString, selectedId = null) => {
    const pageNumber = page + 1;

    const queryParams = new URLSearchParams({
      ...filters,
      page: pageNumber,
    });

    const url = `academics/get-academic-groups-with-pagination/?${queryParams.toString()}`;

    // Spinner handling
    if (skipSpinnerRef.current) {
      skipSpinnerRef.current = false;
    } else {
      if (isInitialLoad) setIsLoading(true);
      else setSearchLoading(true);
    }

    try {
      const response = await getData(url);

      const results = Array.isArray(response?.results) ? response.results : [];
      // Flatten all results before setting state
      const flattenedResults = flattenClassData(results);
      // Update state
      setClassData(results);           // raw data if needed
      setFilteredData(flattenedResults); // formatted for table
      setTotalCount(response?.count || 0);
      // setdnparentdata(results);
      // Select first row or by selectedId
      let selectedOrg = selectedId
        ? flattenedResults.find(item => item.id === selectedId)
        : flattenedResults[0];

      setSelectedOrgDetails(selectedOrg || null);

      if (selectedOrg?.id) getdeptdata(selectedOrg.id);
    } catch (error) {
      console.error("Error fetching academic groups", error);
      setClassData([]);
      setFilteredData([]);
      setTotalCount(0);
      setdnparentdata([]);
      setSelectedOrgDetails(null);
    } finally {
      if (!skipSpinnerRef.current) {
        if (isInitialLoad) {
          setIsLoading(false);
          setIsInitialLoad(false);
        } else {
          setSearchLoading(false);
        }
      }
    }
  };


  // useEffect(() => {
  //   getorgdata(classPage);
  // }, [classPage]);

  const currentPageRef = useRef(currentPage);


  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (isSearching && refreshKey === 0) return;
    currentPageRef.current = currentPage;

    const fetchData = async () => {
      await getorgdata(currentPageRef.current, filterQueryString);
      stopTableLoading(); // hide overlay
    };

    fetchData();
    // getItems(currentPageRef).finally(() => stopTableLoading())
  }, [currentPage, filterQueryString, refreshKey]);


  const handleRowClick = async (id, row) => {
    const org = row.original;
    setSelectedOrgDetails({
      id: org.id, // class ID
      class_name: org.class_name || org.name,
      academic_group: org.academic_group || org.name,
      // Specialization info (flat values)
      specialization: org.specialization || "N/A",
      specialization_id: org.specialization_id || null,
      // Course info (flat values from flattened object)
      course: org.alias || "N/A",               // alias = short form
      course_id: org.course_id || null,
      course_name: org.course || "N/A",
      level: org.level || "N/A",
      mode: org.mode || "N/A",
      duration: org.duration || "N/A",
      mode_count: org.mode_count || 0,
      // Organization info
      organization: org.organization || "N/A",
      organization_id: org.organization_id || null,
      fees: org?.fees ? org.fees : "00",
      provisional_fee: org?.provisional_fee ? org.provisional_fee : "00",
      intake_limit: org?.intake_limit ? org.intake_limit : "00",
      status: org.status
    });
    try {
      const res = await getData(`students/get-least-academic-groups-by-academic-group/?academic_group_id=${org.id}`);

      if (res) {
        setdepartmentdetails(res);
      }
    } catch (err) {
      displayToast('Failed to load department/class data:', 'danger');
    }
  };





  const getorgdata2 = async () => {
    const url = "administration/organizations/";
    const response = await getData(url);
    if (response) {
      setdnparentdata2(response);

    }

  }
  const getdeptdata = async (id) => {
    if (!id) {
      return;
    }
    setparentorgid(id);
    const url = `students/get-least-academic-groups-by-academic-group/?academic_group_id=${id}`;
    try {
      const response = await getData(url);

      if (response) {
        setdepartmentdetails(response);
      } else {
        displayToast('No department data found.', 'warning');
      }
    } catch (error) {

      displayToast('Error fetching department data', 'danger');
    }
  };




  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'name') {

      if (/^\d/.test(value)) return;
      setorgform(prev => ({ ...prev, [name]: value }));

    } else if (name === 'intakelimit' || name === 'duration' || name === 'mode_count') {

      const validNumber = value.replace(/\D/g, '');
      setorgform(prev => ({ ...prev, [name]: validNumber }));

    } else {

      setorgform(prev => ({ ...prev, [name]: value }));
    }
  };


  const handleChangedept = (e) => {
    const { name, value } = e.target;
    setdeptform(prevState => ({
      ...prevState,
      [name]: value
    }));
  }
  const handleSubmit = async () => {

    // if (!isRequired(orgform.academic_group) || !isRequired(orgform.academic_group)) return displayToast('Academic Group is Required', 'danger');
    if (!isRequired(orgform.name)) return displayToast(' Class is required', 'danger');
    if (!isRequired(orgform.intakelimit) || !isRequired(orgform.intakelimit)) return displayToast('Intake Limit is required', 'danger');

    const finalobj = {
      name: orgform.name,
      academic_group_id: selectedOrgDetails.id,
      intake_limit: orgform.intakelimit

    }

    const url = 'academics/least-academic-group/';
    const response = await PostdataWithJson(url, finalobj);

    if (response && !response.error) {
      displayToast('Class Added successfully!', 'success');
      // getorgdata();
      // getdeptdata(selectedOrgDetails.id)
      setRefreshKey(prev => prev + 1)
      closeModal();
    } else if (response && response.error) {
      const errorMsg = response.error?.[0] || 'Error Adding Class.';
      displayToast(errorMsg, 'danger');
    } else {
      displayToast('Unexpected error occurred.', 'danger');
    }
  }
  const handleSubmitdept = async () => {
    const finalobj = {
      id: deptform.id,
      name: deptform.name,
      course_code: deptform.course_code,
      semester_fee: deptform.semester_fee,
      provisional_fee: deptform.provisional_fee,
      intech_capacity: parseInt(deptform.intech_capacity)
    }
    const url = `academics/courses/${parentorgid ? parentorgid : finalobj.id}/specializations/`;
    const response = PostdataWithJson(url, finalobj);
    if (!response.error) {
      getdeptdata(parentorgid)
    }

  }

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setUpdatebtn(false);
    handleClear();

  };

  const openFeeModal = () => {
    setIsFeeModalOpen(true);
  };

  const closeFeeModal = () => {
    setIsFeeModalOpen(false);
    setUpdatebtn(false);
    handleClear();
  };
  const openModaldept = () => {
    setIsModalOpendept(true);
  };
  const closeModaldept = () => {
    setIsModalOpendept(false);
    handleCleardept();
    setUpdatebtn(false);
  };
  const submitclose = () => {
    setsubmit(false);
  };




  const handleUpdateFee = async () => {
    if (!isRequired(feeForm.provisional_fee)) return displayToast('Provisional is required', 'danger');
    if (!isRequired(feeForm.fees)) return displayToast('Fee is required', 'danger');
    if (!isRequired(feeForm.intake_limit)) return displayToast('Intake limit is required', 'danger');

    const finalobj = {
      provisional_fee: feeForm.provisional_fee || 0,
      fees: feeForm.fees || 0,
      intake_limit: feeForm.intake_limit || 0,
      specialization_id: selectedOrgDetails?.specialization_id,
    };

    const url = `academics/update-academic-groups/${orgform.id}/`;
    const response = await UpdateDataFormWithJson(url, finalobj);

    if (response && !response.error) {
      displayToast('Fee updated successfully!', 'success');

      // Use current page and selected ID to reload data
      getorgdata(currentClassPage, selectedOrgDetails?.id);
      getdeptdata(selectedOrgDetails.id);
      closeFeeModal();
    } else if (response && response.error) {
      const errorMsg = response.error?.[0] || 'Error updating fee.';
      displayToast(errorMsg, 'danger');
    } else {
      displayToast('Unexpected error occurred.', 'danger');
    }
  };










  const [orgs, setOrgs] = useState([]);
  const [courses, setCourses] = useState([]);
  const [semesters, setSemesters] = useState([]);

  const [org, setOrg] = useState([]);

  useEffect(() => {
    if (isModalOpen) {
      getOrganizations();
    }
  }, [isModalOpen]);

  const getOrganizations = async () => {
    const response = await getData('administration/organizations/');
    if (response) {
      const formatted = response?.map((org) => ({
        id: org.id,
        name: org.organization_name || org.name,
      }));
      setOrgs(formatted);
    }
  };

  const getCourses = async (orgId) => {
    const res = await getData(`students/get-course-list-by-organization/?organization_id=${orgId}`);
    if (res && Array.isArray(res)) {
      const formatted = res?.map((r) => {
        const name = r.course_specialization?.trim() || r.course?.name?.trim() || 'Unnamed Course';
        return { id: r.id, name };
      });
      setCourses(formatted);
      setSemesters([]);
      return formatted;
    }
    return [];
  };


  const getSemesters = async (courseId) => {
    const res = await getData(`students/get-academic-groups-by-specialization/?specialization_id=${courseId}`);
    if (res && Array.isArray(res)) {
      const formatted = res?.map((s) => ({ id: s.id, name: s.name }));
      setSemesters(formatted);
    }
  };
  const handleEdit = async (row) => {
    const orgData = row.original;
    setorgform({
      id: orgData.id,
      name: orgData.class_name,
      academic_group: orgData.academic_group_id,
      intakelimit: orgData.intake_limit,
      courseid: orgData.course_id,
      specid: orgData.spec_id,

    });

    setparentorgidsub(orgData.id);
    openFeeModal();
    setUpdatebtn(true);

    try {
      const apiUrl = 'academics/least-academic-group';
      const academicGroupDetails = await getDataById(apiUrl, orgData.id);


      if (academicGroupDetails) {
        const group = academicGroupDetails.academic_group;
        const specialization = group.specialization;
        const course = specialization.course;
        const organization = course.organization;

        const courseId = course.id;
        const semesterId = group.id;


        setorgform(prev => ({
          ...prev,
          courseid: courseId,
          specid: semesterId,
        }));

        setOrg([{
          id: organization.id,
          name: organization.name
        }]);


        setCourses([{
          id: courseId,
          name: course.name
        }]);

        setSemesters([{
          id: semesterId,
          name: group.name
        }]);


      }

    } catch (error) {

    }
  };



  const handleEditdept = (row) => {

    setorgform(
      {
        id: row.id,
        name: row.name,
        intakelimit: parseInt(row.intake_limit)
      }
    )
    setUpdatebtn(true);
    openModal()

  }
  const handleupdatedept = async () => {
    const finalobj = {
      id: deptform.id,
      name: deptform.name,
      course_code: deptform.course_code,
      semester_fee: deptform.semester_fee,
      provisional_fee: deptform.provisional_fee,
      intech_capacity: parseInt(deptform.intech_capacity)
    }
    const url = `academics/courses/${parentorgid}/specializations/${finalobj.id}/`

    const response = await updateData(url, finalobj);

    if (response) {
      closeModaldept();
      displayToast('Class Updated successfully!', 'success');
      setUpdatebtn(false);
      getdeptdata(parentorgid);
    }
  }
  const handleUpdate = async () => {
    const finalobj = {
      id: parseInt(orgform.id),
      name: orgform.name,
      academic_group_id: selectedOrgDetails.id,
      intake_limit: orgform.intakelimit,
    }

    const url = `academics/least-academic-group/${finalobj.id}/`
    const response = await updateData(url, finalobj);

    if (!response.error) {
      setRefreshKey(prev => prev + 1)
      setUpdatebtn(false);
      closeModal();
    }

  }


  const handleClear = () => {
    setorgform(
      {
        orgname: '',
        parentorgidog: null,
        gstin: '',
        email: '',
        landlineno: '',
        mobileno: '',
        address: '',
        pincode: '',
        countrycode: '1'
      }
    )
    setparentorgidsub(null);
    setstateid(null);
    setcountryId(null);

  }
  const handleCleardept = () => {
    setdeptform({
      name: "",
      parent_department_id: null,
      country_code: "",
      area_code: '',
      landline: "",
      mobile: "",
      email: ""
    })
    setUpdatebtn(false);
  }
  const handleStatus = async (row) => {
    const newStatus = !row.original.status;
    row.original.status = newStatus;
    const url = `academics/least-academic-group/${row.original.id}/`;
    const response = await patchData(url, { status: newStatus });

    if (response && !response.error) {
      displayToast('Status Updated successfully!', 'success');
      getorgdata();
    } else if (response && response.error) {
      const errorMsg = response.error?.[0] || 'Error Updating Status.';
      displayToast(errorMsg, 'danger');
    } else {
      displayToast('Unexpected error occurred.', 'danger');
    }

  };
  const handleStatusDept = async (department) => {

    const newStatus = !department.status;
    const updatedDepartmentDetails = departmentdetails?.map(dept => {
      if (dept.id === department.id) {
        return { ...dept, status: newStatus };
      }
      return dept;
    });

    setdepartmentdetails(updatedDepartmentDetails);

    const url = `academics/courses/${parentorgid}/specializations/${department.id}/`;
    const response = await patchData(url, { status: newStatus });

    if (response) {

    } else {
      displayToast("Failed to update department status.", 'danger');
    }
  };


  const handleStatusUpdateClass = async (department) => {
    const newStatus = !department.status;
    const updatedDepartmentDetails = departmentdetails?.map(dept => {
      if (dept.id === department.id) {
        return { ...dept, status: newStatus };
      }
      return dept;
    });

  };



  const handleFeeChange = (e) => {
    const { name, value } = e.target;
    // Allow only digits and one optional decimal point
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setFeeform(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };


  useEffect(() => {
    getorgdata();

    getdeptdata();
    getmasterdata();
    getorgdata2();
    getcourse();
  }, [])
  useEffect(() => {
    getspec();
  }, [orgform.courseid])

  // useEffect(() => {
  //   if (selectedOrgDetails) {
  //     setFeeform({
  //       provisional_fee: selectedOrgDetails.provisional_fee ?? "00",
  //       fees: selectedOrgDetails.fees ?? "00", // this is the field you're missing
  //       intake_limit: selectedOrgDetails.intake_limit ?? "00"
  //     });
  //   }
  // }, [selectedOrgDetails]);

  const searchInputRef = useRef(null);

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);



  const sourceData = useMemo(() => {
    return filterQueryString ? filteredData : classData;
  }, [classData, filteredData, filterQueryString]);

  const formattedData = useMemo(() => {
    // If filteredData came from search, it's already flattened
    const dataToFlatten = filterQueryString ? filteredData : sourceData;
    return filterQueryString ? dataToFlatten : flattenClassData(dataToFlatten);
  }, [sourceData, filteredData, filterQueryString]);



  const columns = useMemo(() => [
    // {
    //   Header: <input type='checkbox' />,
    //   accessor: 'checkbox',
    //   Cell: ({ row }) => (
    //     <input
    //       type="checkbox"
    //       checked={row.isSelected}
    //       onChange={() => row.toggleRowSelected()}
    //       style={{ cursor: 'pointer' }}
    //     />
    //   )
    // },
    {
      Header: 'Course Name (Specialization)',
      accessor: 'course',
      disableSortBy: true,
      Cell: ({ row }) => {

        const course = row.original.course




        return (
          <div style={{ cursor: 'pointer' }}
          >
            <p style={{ margin: 0, color: '#222F3E', fontWeight: 500, textAlign: "left" }}>
              {course} {/*{specialization ? ` (${specialization})` : ''}*/}
            </p>
          </div>
        );
      }
    },
    {
      Header: 'Course code',
      accessor: 'course_code',
      disableSortBy: true,
      Cell: ({ row }) => (
        <div >
          <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>  {row.original.course_code || ""}</p>
        </div>
      )
    },

    {
      Header: 'Academic Group',
      accessor: 'academic_group',
      disableSortBy: true,
      Cell: ({ row }) => (

        <div >

          <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>    {row.original.academic_group || ""}</p>
        </div>
      )
    },

  ], []);

  const handleSetSearchResults = (data) => {
    const results = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : [];
    const flattenedResults = flattenClassData(results);

    setFilteredData(flattenedResults);

    if (flattenedResults.length > 0) {
      setSelectedOrgDetails(flattenedResults[0]);
      getdeptdata(flattenedResults[0].id);
    } else {
      setSelectedOrgDetails(null);
    }
  };


  return (
    <>   {isLoading ? (
      <TableSkeleton rows={10} columns={6} showHeader={true} />
    ) :
      (
        <div style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
          position: "relative",
        }}>

          {/* ✅ FIXED: Title + Search */}
          <div style={{ flexShrink: 0, padding: "0 12px" }}>
            <div className="row mt-3" style={{ alignItems: 'center' }}>
              <div className="col-md-6">
                <h2 className='main-heading'>Academic Group({totalCount})</h2>
              </div>
              <div className="col-md-6">
                <div style={{ display: "flex", justifyContent: 'end' }}>
                  <SearchingBar
                    placeholder="Search by Course code, academic group ..."
                    url="academics/get-academic-groups-with-pagination/"
                    filterQueryString={filterQueryString}
                    setResults={handleSetSearchResults}
                    ref={searchInputRef}
                    setTotalCount={setTotalCount}
                    setFilterQueryString={setFilterQueryString}
                    setIsLoading={setIsLoading}
                    setSearchLoading={setSearchLoading}
                    setCurrentPage={setCurrentPage}
                    setIsSearching={setIsSearching}
                    onTransitionChange={setIsSearchPending}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* ✅ SCROLLABLE BODY: Table (left) + Side Panel (right) */}
          <div className='mt-3' style={{ display: "flex", flex: 1, minHeight: 0, overflow: "hidden", padding: "0 12px" }}>

            {/* LEFT: Table — only tbody scrolls */}
            <div style={{
              flex: "0 0 66.67%",
              maxWidth: "66.67%",
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              overflow: "hidden",
              paddingRight: "12px"
            }}>
              {showSpinner ? (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '60vh'
                }}>
                  <SpinnerLoader />
                </div>
              ) : formattedData && formattedData?.length > 0 ? (
                < >
                  <AdvanceTable
                    columns={columns}
                    pageCounts={pageCounts}
                    handlePageChange={handleClassPageChange}
                    selectedData={selectedOrgDetails}
                    data={formattedData}
                    handleRowClick={handleRowClick}
                    currentPage={currentPage}
                    checkbox={false}
                  />
                  <TableLoaderOverlay isLoading={tableLoading} />
                </>
              ) : (!isLoading && !isSearchLoading && (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '60vh',
                  color: '#888',
                  textAlign: 'center',
                }}>
                  No Data found.
                </div>
              ))}
            </div>

            {/* RIGHT: Side Panel */}
            <div className="shortdetails" style={{
              flex: "0 0 33.33%",
              maxWidth: "33.33%",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}>
              <ClassShortDetails
                navigate={navigate}
                openModaldept={openModaldept}
                closeModaldept={closeModaldept}
                isModalOpendept={isModalOpendept}
                selectedOrgDetails={selectedOrgDetails}
                departmentdetails={departmentdetails}
                deptform={deptform}
                handleChangedept={handleChangedept}
                handleSubmitdept={handleSubmitdept}
                handleEditdept={handleEditdept}
                Updatebtn={Updatebtn}
                handleupdatedept={handleupdatedept}
                handleCleardept={handleCleardept}
                handleStatusDept={handleStatusDept}
                isModalOpen={isModalOpen}
                orgform={orgform}
                handleSubmit={handleSubmit}
                handleUpdate={handleUpdate}
                handleChange={handleChange}
                setorgform={setorgform}
                orgs={orgs}
                courses={courses}
                semesters={semesters}
                getOrganizations={getOrganizations}
                getCourses={getCourses}
                getSemesters={getSemesters}
                setCourses={setCourses}
                setSemesters={setSemesters}
                dnparentdata={dnparentdata}
                countrydata={countrydata}
                statedata={statedata}
                citydata={citydata}
                setparentorgidsub={setparentorgidsub}
                parentorgidsub={parentorgidsub}
                countryId={countryId}
                stateid={stateid}
                masterdata={masterdata}
                dnparentdata2={dnparentdata2}
                coursedata={coursedata}
                specdata={specdata}
                org={org}
                onClose={closeModal}
                openModal={openModal}
                handleStatusUpdateClass={handleStatusUpdateClass}
              />
            </div >
          </div >

        </div >
      )}


      <div>
        <Addfee isOpen={isFeeModalOpen} onClose={closeFeeModal} selectedOrgDetails={selectedOrgDetails} handleFeeChange={handleFeeChange} setFeeform={setFeeform} feeForm={feeForm} Updatebtn={Updatebtn} handleUpdateFee={handleUpdateFee}
        />
      </div>

      {
        showToast && (
          <div
            className={`custom-toast toast align-items-center text-white bg-${toastVariant} border-0 position-fixed top-0 end-0 m-3`}
            role="alert"
            style={{
              display: 'block',
              minWidth: '300px',
              maxWidth: '400px',
              borderRadius: '8px',
              boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
              fontSize: '15px',
              zIndex: 9999
            }}
          >
            <div className="d-flex">
              <div className="toast-body" style={{ padding: '12px 16px' }}>
                <strong>{toastVariant === 'success' ? '✅' : '❌'} </strong> {toastMessage}
              </div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 m-auto"
                onClick={() => setShowToast(false)}
                aria-label="Close"
              ></button>
            </div>
          </div>

        )
      }
      {submit === true ? <SuccessfulPopup mainheading={'Registration Completed Successfully!'} submitclose={submitclose} /> : ''}
    </>
  );
};


